import api from './axios';

export const listar = (params = {}) => api.get('/eventos/', { params });
export const obter = (id) => api.get(`/eventos/${id}`);
// sistemas que aparecem nos eventos gravados — fonte do filtro da tela
export const sistemas = () => api.get('/eventos/sistemas');
export const reenviar = (id, urlDestino) => api.post(`/eventos/${id}/reenviar`, { url_destino: urlDestino || null });
export const excluir = (id) => api.delete(`/eventos/${id}`);
